import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCounterofferAdjust = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 10.5H22",
			stroke: "black",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5483 20.9998H6.43829C2.88829 20.9998 1.98828 20.1198 1.98828 16.6098V8.38977C1.98828 5.20977 2.72831 4.18977 5.51831 4.02977C5.79831 4.01977 6.10829 4.00977 6.43829 4.00977H17.5483C21.0983 4.00977 21.9983 4.88977 21.9983 8.39977V12.8098",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 16.5H9",
			stroke: "black",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 16.5H13.5",
			stroke: "black",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.0764 15.94L15.3664 19.65C15.2264 19.79 15.0864 20.07 15.0564 20.27L14.8564 21.69C14.7864 22.2 15.1464 22.56 15.6564 22.49L17.0764 22.29C17.2764 22.26 17.5564 22.12 17.6964 21.98L21.4064 18.27C22.0464 17.63 22.3464 16.89 21.4064 15.95C20.4564 15 19.7164 15.3 19.0764 15.94Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5459 16.47C18.8659 17.6 19.7459 18.48 20.8659 18.79",
			stroke: "black",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCounterofferAdjust;
